<app-modal [show]="showModal" (close)="fecharModal()" [title]="title" class="min-w-full">
  <app-confirm-dialog
    [show]="showConfirmDialog"
    [message]="message"
    (confirm)="onConfirm()"
    (cancel)="onCancel()"
  ></app-confirm-dialog>

  <app-table [columns]="columns" [data]="data"></app-table>
</app-modal>
<app-loading [show]="loading"></app-loading>
